import React from 'react'

import _ from 'underscore'

import {Alert, Button, IconButton, Modal, ModalHeader, ModalActions, ProgressBar} from '../UI/index.js'
import {formSpacing, CurrencyInput, RadioButton, Check, FormRow, FormStack, Input, Select} from '../UI/forms/index.js'

class EditPricePopup extends React.Component {
    constructor(props) {
        super(props)
        this.initialState = {
            isOpen: false,
            fees: [],
            removeOldFees: false,
            newPrice: '',
            pricingOption: '',
            loading: false,
            progressNow: 0,
            progressMax: null,
            onConfirm: null,
            onClose: null,
            message: '',
            error: '',
            errors: []
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open(onConfirm) {
        this.setState({isOpen: true, onConfirm})
    }

    close() {
        this.setState(this.initialState)
    }

    onChangeFee(key, index, event) {
        const fees = [...this.state.fees]
        const {reseller} = this.props

        if (key === 'quantity') {
            fees[index].quantity = parseInt(event.target.value) || 0
        } else {
            const selectedFee = _.findWhere(reseller.settings.parcels.fees, {id: event.target.value})

            if (selectedFee && selectedFee.id) {
                const fee = JSON.parse(JSON.stringify(selectedFee))
                fee.quantity = 1

                if (fee.basedOn && fee.basedOn !== 'fixedPrice') {
                    fee.percentage = fee.price
                }

                fees[index] = fee
            }
        }

        this.setState({fees})
    }

    onClickAddFee() {
        const fees = [...this.state.fees]
        const {reseller} = this.props

        if (reseller.settings.parcels.fees) {
            const fee = JSON.parse(JSON.stringify(reseller.settings.parcels.fees[0]))

            if (fee && fee.id) {
                fees.push({
                    id: fee.id,
                    description: fee.description,
                    price: fee.price,
                    percentage: fee.basedOn && fee.basedOn !== 'fixedPrice' ? fee.price : undefined,
                    basedOn: fee.basedOn,
                    productCode: fee.productCode,
                    quantity: 1
                })

                this.setState({fees})
            }
        }
    }

    onClickRemoveFee(index) {
        const fees = [...this.state.fees]
        fees.splice(index, 1)
        this.setState({fees})
    }

    onClickConfirm() {
        this.setState({loading: true, message: '', error: ''})
        const {fees, removeOldFees, pricingOption, newPrice} = this.state

        typeof this.state.onConfirm === 'function' && this.state.onConfirm(fees, removeOldFees, pricingOption, newPrice)
    }

    setMessage(message) {
        this.setState({message, loading: false})
    }

    setError(error) {
        this.setState({error, loading: false})
    }

    setErrors(errors) {
        this.setState({errors, loading: false})
    }

    setProgress(progressNow, progressMax) {
        this.setState({progressNow, progressMax})
    }

    render() {
        const {isOpen, fees, removeOldFees, newPrice, pricingOption, progressNow, progressMax, onConfirm, loading, message, error, errors} = this.state
        const {reseller} = this.props

        return (
            <Modal show={isOpen} style={{width: errors.length > 0 ? 800 : 600, maxWidth: '90%'}} onClose={this.close.bind(this)}>
                <ModalHeader title='Wijzig zending prijs' />

                <br />
                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Check
                        label='Verwijderen oude toeslagen'
                        checked={removeOldFees}
                        onChange={(event) => this.setState({removeOldFees: event.target.checked})}
                        disabled={error || message}
                    />

                    <RadioButton
                        label='Herbereken prijs volgens tarieftabel'
                        checked={pricingOption === 'recalculatePrice'}
                        value='recalculatePrice'
                        onChange={(event) => this.setState({pricingOption: event.target.value})}
                        disabled={error || message}
                    />

                    <FormRow>
                        <RadioButton
                            style={{width: '100%'}}
                            label='Wijzig prijs'
                            checked={pricingOption === 'newPrice'}
                            value='newPrice'
                            onChange={(event) => this.setState({pricingOption: event.target.value})}
                            disabled={error || message}
                        />
                        <CurrencyInput
                            style={{width: '45%'}}
                            label='prijs'
                            value={newPrice}
                            onChange={(event) => this.setState({newPrice: event.target.value})}
                            disabled={(pricingOption !== 'newPrice') || (error || message)}
                        />
                    </FormRow>
                </FormStack>

                <br />

                {fees.map((fee, index) => {
                    return (
                        <div key={`fee${index}`} style={{display: 'flex', alignItems: 'center', columnGap: formSpacing.columnGap, marginBottom: 12}}>
                            <Select
                                label='Toeslag'
                                options={(reseller.settings.parcels.fees || []).map((fee) => {
                                    if (fee.id) {
                                        return {title: fee.description, value: fee.id}
                                    }
                                })}
                                value={fee.id}
                                onChange={this.onChangeFee.bind(this, 'id', index)}
                                disabled={error || message}
                            />

                            <Input
                                type='number'
                                noPlaceholder
                                style={{maxWidth: 80}}
                                label='Aantal'
                                value={fee.quantity}
                                onChange={this.onChangeFee.bind(this, 'quantity', index)}
                                disabled={error || message}
                            />

                            <IconButton
                                onClick={this.onClickRemoveFee.bind(this, index)}
                                disabled={error || message}
                            >
                                <i className='mdi mdi-delete' />
                            </IconButton>
                        </div>
                    )
                })}

                {reseller.settings.parcels.fees?.length > 0 && (
                    <Button
                        style={{marginBottom: 12}}
                        variant='outline-white'
                        icon='mdi mdi-plus'
                        label='Nieuwe toeslag'
                        onClick={this.onClickAddFee.bind(this)}
                        disabled={error || message}
                    />
                )}

                {progressMax && !message && !error &&
                    <ProgressBar style={{marginBottom: 16}} now={progressNow} max={progressMax} />
                }

                {message &&
                    <Alert style={{marginBottom: 6}} variant='success'>{message}</Alert>
                }

                {error &&
                    <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>
                }

                {errors.length > 0 && errors.map((error, index) => {
                    return <Alert style={{marginBottom: 6}} key={`error${index}`} variant='danger'>{error}</Alert>
                })}

                <ModalActions>
                    {loading && progressNow !== progressMax &&
                        <Button
                            variant='outline-white'
                            onClick={() => this.setState({stopOperation: true, progressNow: progressMax, loading: false}, this.close)}
                        >
                            Afbreken
                        </Button>
                    }

                    {!message && !loading && !error &&
                        <Button
                            variant='text'
                            onClick={this.close.bind(this)}
                        >
                            Annuleren
                        </Button>
                    }

                    {onConfirm && !message && !error &&
                        <Button
                            variant='text'
                            loading={loading}
                            onClick={() => this.setState({stopOperation: false}, this.onClickConfirm)}
                        >
                            Bevestigen
                        </Button>
                    }

                    {(message || error) &&
                        <Button
                            variant='text'
                            onClick={this.close.bind(this)}
                        >
                            Sluiten
                        </Button>
                    }
                </ModalActions>
            </Modal>
        )
    }
}

export default (EditPricePopup)
